import React from 'react';

import {observer} from 'mobx-react';

import ButtonHoc from '../ButtonHoc/ButtonHoc';
import styles from './ButtonBack.module.scss';

interface ButtonBackProps {
    onClick?: () => void;
    disabled?: boolean;
    className?: string;
}

const ButtonBack: React.FC<ButtonBackProps> = ({onClick, disabled, className}) => {
    return (
        <ButtonHoc className={[styles.ButtonBack, className].join(' ')} onClick={onClick} disabled={disabled}>
            <div />
        </ButtonHoc>
    );
};

export default observer(ButtonBack);
